// import SaveIcon from "@mui/icons-material/Save";
import ActionButton from "controls/global/action-button/ActionButton";
import { useConfigurationProvider } from "pages/signatures/providers/manage-signature/ConfigurationProvider";
import { useSignatureProvider } from "pages/signatures/providers/manage-signature/SignatureProvider";
// import { useWizardProvider } from "pages/signatures/providers/manage-signature/WizardProvider";
import React, { useState } from "react";
import { useSignatures } from "utils/context/SignaturesContext";
import { v4 as uuidv4 } from "uuid";
import { useGlobalAccess } from "utils/context/GlobalAccessContext";
import { showToast } from "controls/global/stewart-toast/showToast";
import { UIConstants } from "utils/data/enum";
import useSignature from "utils/custom-hooks/useSignature";
// import { usePaginationProvider } from "pages/signatures/providers/manage-signature/PaginationProvider";

type Props = {
  resetProviders?: () => void;
  hasChanges?: boolean;
  refreshPage?: () => void;
};

export default function SaveButton({ resetProviders, hasChanges, refreshPage, }: Props) {
  const [{ selectedAgency },] = useGlobalAccess();
  const [
    { cachedSignature },
    { saveSignature },
  ] = useSignatures();
  const { refreshAllSignaturesStateContext } = useSignature();  
  // const { state: {
  //   signatureDefaultPagination, 
  // }, } = usePaginationProvider();

  // const {
  //   state: { activeStep },
  // } = useWizardProvider();
  const {
    state: { signature, mode, imageSource, isNameValid, isCheckingName },
  } = useSignatureProvider();
  const {
    state: { nodes, hasSelectedNodes, onClose },
  } = useConfigurationProvider();

  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (isSaving) return;
    setIsSaving(true);

    try {
      let result;
      if (mode === "ADD") {
        result = await saveSignature({
          signatureImageID: 0,
          signatureImageName: signature.name.trim(),
          signatureImageDescription:
            imageSource === "TYPE" ? signature.signatureDescription || "" : "",
          signatureImageSourceTypeCode: imageSource,
          signatureImageFontTypeCode:
            imageSource === "TYPE" ? signature.fontFamilyID : "",
          signatureImageFormatTypeCode: signature.imageType,
          signatureImageData: signature.file,
          signatureLevelTypeCode: signature.signatureLevelTypeCode,
          signatureConfiguration: nodes || undefined,
          integrationKey: uuidv4(),
          isDefaulted: 0,
          isDefaultedByOther: 0,
        });
        if (result?.success && onClose) {
          showToast({
            type: "success",
            title: UIConstants.SIGNATURE_CREATE_SUCCESS_MESSAGE.toString(),
          });
          refreshPage && refreshPage();
          onClose();
          resetProviders && resetProviders();
          refreshAllSignaturesStateContext(selectedAgency[0]?.CompanyID);
        } else {
          showToast({
            type: "error",
            title: UIConstants.SIGNATURE_CREATE_ERROR_MESSAGE.toString(),
          });
        }
      } else if (mode === "EDIT" && cachedSignature) {
        result = await saveSignature({
          ...cachedSignature,
          signatureImageName: signature.name.trim(),
          signatureImageDescription:
            imageSource === "TYPE" ? signature.signatureDescription || "" : "",
          signatureImageData: signature.file,
          signatureImageFontTypeCode:
            imageSource === "TYPE" ? signature.fontFamilyID : "",
          signatureImageFormatTypeCode: signature.imageType,
          signatureConfiguration: cachedSignature.signatureConfiguration,
          signatureImageSourceTypeCode: imageSource,
          signatureLevelTypeCode: signature.signatureLevelTypeCode,
        });
        if (result?.success) {
          showToast({
            type: "success",
            title: UIConstants.SIGNATURE_UPDATE_SUCCESS_MESSAGE.toString(),
          });
          onClose && onClose();
          resetProviders && resetProviders();
          // await getSignatures(selectedAgency[0]?.CompanyID);
          refreshPage && refreshPage();
          refreshAllSignaturesStateContext(selectedAgency[0]?.CompanyID);
        } else {
          showToast({
            type: "error",
            title: UIConstants.SIGNATURE_UPDATE_ERROR_MESSAGE.toString(),
          });
        }
      }

    } catch (error) {
      showToast({
        type: "error",
        title:
          mode === "ADD"
            ? UIConstants.SIGNATURE_CREATE_ERROR_MESSAGE.toString()
            : UIConstants.SIGNATURE_UPDATE_ERROR_MESSAGE.toString(),
      });
    } finally {
      setIsSaving(false);
    }
  };

  const isSaveDisabled = () => {
    // Common required fields (BOTH modes)
    if (!isNameValid || isCheckingName || isSaving) return true;
    
    const checkTypeDescription = imageSource === "TYPE" && (!signature.signatureDescription || signature.signatureDescription.trim() === "");

    if (mode === "ADD") {
      if (!hasSelectedNodes || !signature.file || !signature.name || checkTypeDescription) return true;
    }
    else {
      if (mode === "EDIT") {
        if (!hasChanges || !signature.file || !signature.name || checkTypeDescription) return true;
      }
    }
    return false;
  }

  return (
    <ActionButton
      variant="contained"
      color="primary"
      disabled={isSaveDisabled()}
      onClick={handleSave}
    >
      {mode === "ADD" ? "Add Signature" : "Update Signature"}
    </ActionButton>
  );
}
